/**
 * M12 — what ppl are saying. One PPLTalk post from the user's interests.
 * ANONYMOUS register: the author is an @handle and nothing else. Row,
 * class 3, low priority by design — the one module about the network rather
 * than the user's people. The tap is `open` (the post).
 */

import { MessageCircle } from 'react-feather';
import { HomeGlyph, HomeRow } from '../HomeKit';
import { atHandle, plural } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function PostsModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'posts') return null;
  const { payload } = module;
  const act = (a: Parameters<NonNullable<typeof onAction>>[0]) => onAction?.(a, module);
  return (
    <HomeRow
      reason={module.reason}
      body={`“${payload.text}”`}
      sub={`${atHandle(payload.handle)} · ${plural(payload.replyCount, 'reply', 'replies')}`}
      glyph={
        <HomeGlyph tone="dim">
          <MessageCircle size={13} />
        </HomeGlyph>
      }
      dismissable={module.dismissable}
      onDismiss={module.dismissable ? () => act({ kind: 'dismiss', dismissKey: module.dismissKey }) : undefined}
      onOpen={() => act({ kind: 'open' })}
    />
  );
}
